import React from 'react';
import { useHistory } from 'react-router-dom';

import { Modal, Button } from 'antd';

import { Space } from 'v2/components/Shared/Space';

export default function Zapier() {
  const history = useHistory();

  const handleClose = () => {
    const canGoBack = history.action !== 'POP';

    if (!canGoBack) {
      history.push('/producer/dashboard');

      return;
    }

    history.goBack();
  };

  return (
    <div>
      <Modal
        open={true}
        width={600}
        onCancel={_e => {
          handleClose();
        }}
        title={<img height={45} src='/zapier.svg' alt='Zapier logo' />}
        footer={
          <div className='flex items-center justify-end gap-2'>
            <a
              href='https://ajuda.eduzz.com/hc/pt-br/articles/11780815400859-Como-integrar-utilizando-o-Zapier-'
              target='_blank'
              rel='noreferrer'
            >
              Veja nosso FAQ
            </a>
            <Space axis='horizontal' size={8} />
            <a href='https://zapier.com/apps/eduzz/integrations' target='_blank' rel='noreferrer'>
              <Button type='primary'>Integrar agora</Button>
            </a>
          </div>
        }
      >
        <p>
          Agora você pode integrar sua conta da Eduzz e automatizar seu funil de vendas com mais de 5.000 aplicativos,
          para que você possa escalar fazendo o que mais sabe fazer, enquanto automatizamos o resto!
        </p>
        <br />
        <p>
          <a href='https://zapier.com' target='_blank' rel='noreferrer'>
            Conheça mais sobre essa integração
          </a>
        </p>
      </Modal>
    </div>
  );
}
